import * as Yup from 'yup';

export const EmailCelularValidation = Yup.object({
  email: Yup.string().email('Formato de e-mail inválido').matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, 'Formato de e-mail inválido'),
  cel: Yup.string()
    .required("Insira um telefone válido e correto")
    .matches(/^\(\d{2}\)\s\d{4,5}-\d{4}$/, "Insira um telefone válido e correto"),
});